import { _G } from '@/system_modules/utils/_common';
import moment from 'moment-timezone';


export const G = Object.assign(_G, {
    ajaxBaseUrl: {
        // "default": `http://localhost:8000`,
        "default": `https://backend.okcu.az`,
    },

    // ajaxHeaders: {
    //     // 'X-Project-Security': btoa(_G.aEncrypt(btoa(_G.generateRandomSecurityKey()))),
    //     'X-Reguest-With': () => {
    //         // return '__38ap;to34@P(*$#{@)(TWEFS__';
    //         return btoa(_G.exf9(moment.utc().valueOf()) + '.' + _G.exf9('__38ap;to34@P(*$#{@)(TWEFS__'));
    //         // return btoa(_G.aEncrypt(moment.utc().valueOf()) + 'p.|.' + _G.aEncrypt('ui59425W$TGW$5y24greQA43'));
    //     },
    // },
    ajaxHeaders: {
        'X-Reguest-With': () => {
            // let a = _G.exf9('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789ÜİĞÖƏIŞÇüğöəışç!@#$%^&*()_+=-~`}{|":?></.,\';][');
            // console.log("G", moment.utc());
            let a = _G.exf9(moment.utc().valueOf());
            return btoa(a + '.' + _G.exf9('__34fo34PYT#$p8ap;to34@P(*$#{@)(TWEFS__') + '.' + a);
        },
    },

    // mediaURL: `http://127.0.0.1:8000/`,

    main_host: 'okcu.az',

    defaultSelectedMenu: "home",

    defaultPage: "pages/Home",

    projectName: "okcu.az",
    projectSubtitle: "Example subtitle info",
    projectInfo: "",
    // projectInfo: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. <br /> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,

    footerPowered: 'Powered with ♥ by <a href="https://diarc.az" class="footer-info-link mx-1" target="_blank">diarc.az</a> © 2025',
    footerDescription: 'example.az',

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],

    // uploadedFileSize: 52428800,
    uploadedFileSize: 10485760, // 10 Mb

    showFilterAfterLength: 15,

    toastLifeTime: 2000,

    ignored_routes: [
        "pdf_viewer_letter",
        "pdf_viewer",
    ],

});
